import { render, staticRenderFns } from "./ReportNews.vue?vue&type=template&id=363032ae&"
import script from "./ReportNews.vue?vue&type=script&lang=js&"
export * from "./ReportNews.vue?vue&type=script&lang=js&"
import style0 from "./ReportNews.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports